import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModalTypes } from "./modalTypes";

type Modal = {
  type: ModalTypes;
  modalProps?: any;
};

const initialState: {
  currentModal: Modal | null;
} = {
  currentModal: null,
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setModal: (state, action: PayloadAction<Modal | null>) => {
      state.currentModal = action.payload;
    },
  },
});

export const { setModal } = modalSlice.actions;

export default modalSlice.reducer;
